<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-card>
          <div class="publish-btn" :class="hasPerms('event_assign_tasks') ? '' : 'disabled'" @click="createFn"><i class="el-icon-s-promotion"></i> 新赛季启动</div>
          <el-row :gutter="15" class="mb-40" v-for="(pItem, index) in dataList" :key="index">
            <el-col :span="24">
              <el-col :span="12" class="title_row">
                <span class="title_class">{{ pItem.seasonName }}</span>
              </el-col>
              <el-col :span="12" align="right" class="mb-20">
                <span class="slogan">{{ pItem.slogan }}</span>
                <img class="season-icon" :src="pItem.logoUrl" alt="">
              </el-col>
            </el-col>
            <el-col :span="6" v-for="(item, i) in pItem.seasonProductScheduleList" :key="i">
              <div class="camp-item" @click="handleToPage(pItem)">
                <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                <div class="bar"></div>
                <div class="panel panel1">
                  <div class="name">{{ item.scheduleFlagName }}</div>
                  <div class="enName">{{ item.scheduleFlagEnName }}</div>
                  <div class="date">{{ item.beginTime }} ~ {{ item.endTime }}</div>
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        <template v-if="false">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">2025赛季</span>
              <img class="season-icon" src="../../../../../assets/img/season11-4.jpg" alt="">
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) in list" :key="i">
              <div class="camp-item" @click="handleToPage">
                <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                <div class="bar"></div>
                <div class="panel panel1">
                  <div class="name">{{ item.productName }}</div>
                  <div class="enName">{{ item.enName }}</div>
                  <div class="date">{{ item.description }}</div>
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <template v-if="expand">
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">2024～2025 第十赛季</span>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6" v-for="(item, i) in list" :key="i">
                <div class="camp-item">
                  <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                  <div class="bar"></div>
                  <div class="panel panel1">
                    <div class="name">{{ item.productName }}</div>
                    <div class="enName">{{ item.enName }}</div>
                    <!-- <div class="date">{{ item.description }}</div> -->
                    <div class="price">{{ item.price }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">2023～2024 第九赛季</span>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6" v-for="(item, i) in list" :key="i">
                <div class="camp-item">
                  <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                  <div class="bar"></div>
                  <div class="panel panel1">
                    <div class="name">{{ item.productName }}</div>
                    <div class="enName">{{ item.enName }}</div>
                    <!-- <div class="date">{{ item.description }}</div> -->
                    <div class="price">{{ item.price }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
          <div class="bottom-btn" v-if="!expand" @click="expand = true">查看历史赛季信息 <i class="el-icon-caret-bottom"></i></div>
          <div class="bottom-btn" v-if="expand" @click="expand = false">折叠历史赛季信息 <i class="el-icon-caret-top"></i></div>
        </template>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="margin-top: 15px;" v-if="false">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">审核进度</span>
        </el-col>
      </el-row>
      <el-table :data="auditList" style="margin-top: 15px">
        <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
        <el-table-column label="审批等级" align="center">一级部门</el-table-column>
        <el-table-column label="审批意见" align="center">同意</el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
        <el-table-column prop="createTime" label="更新日期" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审批状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditStatus === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 1" type="success" size="small">通过</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 2" type="danger" size="small">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template>
            <el-button type="text" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :title="taskTitle" :visible.sync="taskVisible">
        <el-form ref="form" :model="form" label-width="90px">
          <div class="item">
            <div class="item-title">城市初选</div>
            <el-form-item label="时间周期">
              <el-date-picker style="width: 100%"
                v-model="form.cityPreliminary"
                type="monthrange"
                range-separator="至"
                format="yyyy年M月"
                value-format="yyyy-MM"
                placeholder="请选择时间周期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="定价">
              <el-input v-model="form.cityPreliminaryPrice" clearable placeholder="例：¥380"></el-input>
            </el-form-item>
          </div>
          <div class="item">
            <div class="item-title">城市复选</div>
            <el-form-item label="时间周期">
              <el-date-picker style="width: 100%"
                v-model="form.cityQuarter"
                type="monthrange"
                range-separator="至"
                format="yyyy年M月"
                value-format="yyyy-MM"
                placeholder="请选择时间周期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="定价">
              <el-input v-model="form.cityQuarterPrice" clearable placeholder="例：¥380/¥580"></el-input>
            </el-form-item>
          </div>
          <div class="item">
            <div class="item-title">城市决选/网络决选</div>
            <el-form-item label="时间周期">
              <el-date-picker style="width: 100%"
                v-model="form.citySemi"
                type="monthrange"
                range-separator="至"
                format="yyyy年M月"
                value-format="yyyy-MM"
                placeholder="请选择时间周期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="定价">
              <el-input v-model="form.citySemiPrice" clearable placeholder="例：¥0"></el-input>
            </el-form-item>
          </div>
          <div class="item">
            <div class="item-title">全国总决选</div>
            <el-form-item label="时间周期">
              <el-date-picker style="width: 100%"
                v-model="form.nationalFinals"
                type="monthrange"
                range-separator="至"
                format="yyyy年M月"
                value-format="yyyy-MM"
                placeholder="请选择时间周期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="定价">
              <el-input v-model="form.nationalFinalsPrice" clearable placeholder="例：¥4980"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="taskVisible = false">取 消</el-button>
          <el-button type="primary" @click="startSave">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'

export default {
  name: 'Components',
  data () {
    return {
      taskVisible: false,
      taskTitle: '',
      newSeason: '',
      nextStep: 0,
      expand: false,
      form: {
        cityPreliminary: [],
        cityPreliminaryPrice: '',
        cityQuarter: [],
        cityQuarterPrice: '',
        citySemi: [],
        citySemiPrice: '',
        nationalFinals: [],
        nationalFinalsPrice: ''
      },
      list: [
        {
          productName: '城市初选',
          enName: 'City Preliminary Competitions',
          description: '2025/9-2025/11',
          price: '¥380/¥580'
        },
        {
          productName: '城市复选',
          enName: 'City Quarter-finals',
          description: '2025/12-2026/2',
          price: '¥380/¥580'
        },
        {
          productName: '城市/网络决选',
          enName: 'City Semi-finals',
          description: '2026/2-2026/3',
          price: '¥0'
        },
        // {
        //   productName: '城市总决选',
        //   enName: 'City Finals',
        //   description: '2026/2-2026/3',
        //   price: '¥0'
        // },
        // {
        //   productName: '网络总决选',
        //   enName: 'Online Finals',
        //   description: '2026/2-2026/3',
        //   price: '¥0'
        // },
        {
          productName: '全国总决选',
          enName: 'Naitional Finals',
          description: '2026/4-2026/5 北京',
          price: '¥4980'
        }
      ],
      list2: [],
      auditList: [
        { productName: '2026～2027赛季SPBCN个人赛赛程信息', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ],
      dataList: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.$http.get('seasonProduct/page', { params: { type: 'SPBCN' } }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data
          res.data.forEach(item => {
            if (item.logo) {
              item.logoUrl = JSON.parse(item.logo)[0]
            }
          })
        }
      })
    },
    handleToPage (item) {
      this.$router.push(`/product_Management/publish/event_publish?id=${item.id}&name=${item.seasonName}`)
    },
    createFn () {
      if (!this.hasPerms('event_assign_tasks')) return
      this.$userInfo.getDataList(this, 't_season').then(value => {
        const season = value[value.length - 1]
        this.$confirm(`确认启动${season.dictLabel}赛季？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 确认
          this.checkSeason(season.dictValue)
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
      })
    },
    checkSeason (season) {
      this.newSeason = season
      this.$http.get('seasonProduct/selectBySeason', { params: { type: 'SPBCN', season } }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.$confirm(`${season}赛季已启动，点击确定查看`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handleToPage(res.data)
            })
          } else {
            this.taskTitle = season + '赛季启动'
            this.taskVisible = true
          }
        }
      })
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    },
    startFn () {
      this.taskVisible = true
    },
    startSave () {
      const keys = ['cityPreliminary', 'cityQuarter', 'citySemi', 'nationalFinals']
      const priceKeys = ['cityPreliminaryPrice', 'cityQuarterPrice', 'citySemiPrice', 'nationalFinalsPrice']
      for (const key of keys) {
        if (!this.form[key] || this.form[key].length < 2) {
          this.$message.warning('请完整选择时间周期')
          return
        }
      }
      for (const key of priceKeys) {
        if (!this.form[key] || !this.form[key].trim()) {
          this.$message.warning('请填写定价')
          return
        }
      }

      const scheduleFlagMap = {
        cityPreliminary: 'PRIMARY_SELECTION',
        cityQuarter: 'INDIVIDUAL_FINAL',
        citySemi: 'CITY',
        nationalFinals: 'NATIONAL_FINALS'
      }

      // 从 el-form 的 model 取值（最可靠）
      const formModel = this.$refs.form ? this.$refs.form.model : this.form

      const seasonProductScheduleList = keys.map(key => ({
        beginTime: formModel[key][0],
        endTime: formModel[key][1],
        price: formModel[key + 'Price'] || '',
        scheduleFlag: scheduleFlagMap[key]
      }))

      console.log(formModel, seasonProductScheduleList)

      const params = {
        season: this.newSeason,
        seasonProductScheduleList,
        type: 'SPBCN'
      }
      const now = new Date()
      const yearMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0')
      seasonProductScheduleList.unshift(
        {
          beginTime: yearMonth,
          scheduleFlag: 'START'
        }
      )

      console.log(params)

      this.$http.post('seasonProduct/release', params).then(res => {
        if (res.code === 200) {
          this.$message.success('赛季启动成功')
          this.taskVisible = false
          this.nextStep = 2
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mb-20{
  margin-bottom: 20px;
}
.season-icon{
  width: auto;
  height: 40px;
  object-fit: contain;
  background-color: #0B177C;
  padding: 4px;
  box-sizing: border-box;
  margin-left: 20px;
  vertical-align: middle;
  border-radius: 6px;
}
.slogan{
  font-size: 12px;
  font-weight: bold;
  color: #0B177C;
}
.camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    margin-bottom: 15px;
    .logo{
      position: absolute;
      right: 10px;
      bottom: 10px;
      height: 60px;
      width: auto;
      // opacity: .8;
    }
    &:hover{
      box-shadow: 0 4px 12px 0 rgba(0,0,0,.4);
    }
    .bar{
      width: 100%;
      height: 6px;
      background-color: #0B177C;
      border-radius: 10px 10px 0 0;
    }
    .bar2{
      width: 100%;
      height: 6px;
      background-color: #F67800;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 10px 12px;
      border-radius: 0 0 10px 10px;
      .name{
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
      .enName{
        color: #000;
        font-size: 11px;
        font-weight: bold;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .date{
        color: #666;
        font-size: 12px;
        margin-top: 8px;
        height: 30px;
      }
      .price{
        font-weight: bold;
        font-size: 20px;
        color: rgb(234, 31, 31);
        margin-top: 10px;
      }
      &.panel1{
        background: linear-gradient(140deg, #97a1fb 0%, #fff 70%, #fff 100%);
      }
      &.panel2{
        background: linear-gradient(140deg, #fddcbe 0%, #fff 70%, #fff 100%);
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
.bottom-btn{
  width: 200px;
  margin: 40px auto 0;
  font-size: 14px;
  color: #4096ff;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  i{
    font-size: 20px;
  }
  &:hover{
    text-decoration: underline;
  }
}
.publish-btn{
  background: linear-gradient(140deg, #97a0f8, #fff);
  color: #1826a2;
  width: 100%;
  height: 72px;
  margin: 10px auto 40px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  line-height: 72px;
  border-radius: 6px;
  cursor: pointer;
  &:hover{
    box-shadow: 0 0 10px rgba(11, 23, 124, 0.5);
  }
  &.disabled{
    background: linear-gradient(to left, #cacaca, #ababab);
    color: #fff;
    &:hover{
      box-shadow: none;
    }
  }
}
.start-btn{
  border: 2px dashed #1826a2;
  color: #0B177C;
  background-color: #fff;
}
.new-season{
  min-height: 100px;
}
.item{
  margin-bottom: 20px;
  background-color: #ECF5FF;
  padding: 10px 20px;
}
.item-title{
  font-size: 16px;
  font-weight: bold;
  color: #1826a2;
  margin: 0 0 20px;
  &::after, &::before{
    content: '';
    display: inline-block;
    width: 10px;
    height: 2px;
    background-color: #1826a2;
    margin: 0 4px 4px;
    vertical-align: middle;

  }
}
.mb-40{
  margin-bottom: 40px;
}
</style>
